import React from 'react';
import Paper from '@material-ui/core/Paper';
import { connect } from 'react-redux';

import { treesDataFetcher } from '../../../../dataFetchers/treesDataFetcher';
import { UNITS, FUEL_TYPE, TIMESCALE } from '../../../../constants/common';
import { getFuelUnit } from '../../../../helpers/helper';

class Environment extends React.Component{
  componentDidMount() {
    this.props.treesDataFetcher({
      measurementType: this.props.configs.data.fuelType.toUpperCase(),
      mode: TIMESCALE.YEAR.toLocaleLowerCase(),
      start: 0,
      end: new Date().getTime(),
      userId: this.props.userId
    });
  }

  render(){
    return(
      <Paper className={"environment " +( this.props.halfScreen ? "half-screen" : "")}>
        <div className="info-wrapper">
          <div className={"saving-content "+( this.props.halfScreen ? "half-screen" : "")}>
            {this.props.treesWidgetData.data ? (
              <>
                {this.props.translations.data["HOME.ENVIORONMENT.YOU_NEED"]} 
                  <span className="trees">
                    {this.props.treesWidgetData.data && ' ' + this.props.treesWidgetData.data.noOfTrees} {' ' + this.props.translations.data["HOME.ENVIORONMENT.TREES"]
                  }</span> 
                  &nbsp;
                  {this.props.translations.data["HOME.ENVIORONMENT.TO_BALANCE_YOUR"]} 
                  &nbsp;
                  <span>{this.props.translations.data["HOME.ENVIORONMENT.CO2"]} </span> 
                  <br/> 
                  {this.props.translations.data["HOME.ENVIORONMENT.IMPACT_BASED_ON"]} 
                  &nbsp;
                  <span>{this.props.treesWidgetData.data && this.props.treesWidgetData.data.consumption} {getFuelUnit(this.props.configs.data["fuelType"])}</span> 
                  &nbsp;
                  {this.props.translations.data["HOME.ENVIORONMENT.LAST_PERIOD"]} 
                </>
            ): (
              <>
                {this.props.translations.data["HOME.ENVIORONMENT.YOUR"]}
                &nbsp;
                <span>{this.props.translations.data["HOME.ENVIORONMENT.CO2"]} </span>
                &nbsp;
                {this.props.translations.data["HOME.ENVIORONMENT.WILL_BE_UPDATED"]}
              </>
            )}
          </div>
        </div>
      </Paper>
    )
  }
}

const mapStateToProps = state => {
  return{
    userId : state.userIdentityDetails.userId,
    treesWidgetData : state.treesWidgetReducer,
    translations: state.translationsData,
    configs : state.configs
  }
}

const mapDispatchToProps = dispatch => {
  return{
    treesDataFetcher: (options) => dispatch(treesDataFetcher(options))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Environment);